import { LabCoat, Outerwear, ScrubPants, Socks, Underscrubs } from '@syconium/little-miss-figgy'

import {
  OrganizationEmbroideryTextFont,
  ProductCatalogEmbroideryLocation,
  ProductCatalogEmbroideryPosition,
} from '../../../../../__generated__/graphql/catalog/graphql'
import { StylePreferenceInput } from '../../../../_hooks/useStylePreferences'

export type DefaultPreferencesType = {
  stylePreference: StylePreferenceInput
  sizePreferences: {
    MEN: { settings: { category: string; fit: string | null; size: string | null }[] }
    WOMEN: { settings: { category: string; fit: string | null; size: string | null }[] }
  }
}

export const PREFERENCE_CATEGORY_ICONS = {
  tops: LabCoat,
  pants: ScrubPants,
  outerwear: Outerwear,
  underscrubs: Underscrubs,
  shoes: Socks,
}

export const MENS = ['XS', 'S', 'M', 'L', 'XL', '2XL']
export const MENS_EXTENDED = ['3XL', '4XL', '5XL', '6XL']
export const MENS_SECONDARY = ['regular', 'short', 'tall']

export const WOMENS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL']
export const WOMENS_EXTENDED = ['3XL', '4XL', '5XL', '6XL']
export const WOMENS_SECONDARY = ['regular', 'petite', 'tall']

export const SHOE_SIZES = [
  '5',
  '5.5',
  '6',
  '6.5',
  '7',
  '7.5',
  '8',
  '8.5',
  '9',
  '9.5',
  '10',
  '10.5',
  '11',
  '11.5',
  '12',
  '12.5',
  '13',
  '13.5',
  '14',
  '14.5',
]

const defaultSettings = {
  settings: [
    {
      category: 'tops',
      fit: null,
      size: null,
    },
    {
      category: 'pants',
      fit: null,
      size: null,
    },
    {
      category: 'outerwear',
      fit: null,
      size: null,
    },
    {
      category: 'underscrubs',
      fit: null,
      size: null,
    },
    {
      category: 'shoes',
      fit: null,
      size: null,
    },
  ],
}

export const DEFAULT_PREFERENCE_VALUES: DefaultPreferencesType = {
  stylePreference: 'WOMEN',
  sizePreferences: {
    MEN: defaultSettings,
    WOMEN: defaultSettings,
  },
}

export const PREFERENCE_CATEGORIES: Record<string, string> = {
  tops: 'Scrub Top',
  pants: 'Scrub Pants',
  outerwear: 'Outerwear',
  underscrubs: 'Underscrubs',
  shoes: 'Shoes',
}

export const EMBROIDERY_PLACEMENT = {
  position: {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
  },
  location: {
    CHEST: 'CHEST',
    CALF: 'CALF',
    SIDE: 'SIDE',
    SLEEVE: 'SLEEVE',
    THIGH: 'THIGH',
  },
} as const satisfies {
  position: Record<ProductCatalogEmbroideryPosition, ProductCatalogEmbroideryPosition>
  location: Record<ProductCatalogEmbroideryLocation, ProductCatalogEmbroideryLocation>
}

// Locations that the MyFigs EmbroideryDialog currently supports as preference targets.
// Extend this set when the dialog gains support for a new location, and update <PreferencesToggle> visibility accordingly.
export const PREFERENCE_SUPPORTED_LOCATIONS = new Set<ProductCatalogEmbroideryLocation>([
  EMBROIDERY_PLACEMENT.location.CHEST,
])

export const EMBROIDERY_FONTS = {
  BLOCK: 'BLOCK',
  SCRIPT: 'SCRIPT',
} as const satisfies Record<OrganizationEmbroideryTextFont, OrganizationEmbroideryTextFont>
